// extracted by mini-css-extract-plugin
export default {"root":"chars-counter_root__ALRsd","overflow":"chars-counter_overflow__qRAT-","success":"chars-counter_success__i-c-7","placeHolderShimmer":"chars-counter_placeHolderShimmer__VntMN"};